module.exports = __webpack_public_path__ + "img/world-hand.a4aa7b03.svg";